
const Confidentialite = () => {
  console.log("Confidentialité: Rendering page");
  
  return (
    <div className="container mx-auto px-4 py-8 max-w-4xl">
      <h1 className="text-2xl sm:text-3xl font-bold mb-6 sm:mb-8">Politique de Confidentialité</h1>
      
      <div className="prose max-w-none space-y-6 sm:space-y-8">
        <section>
          <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4">1. Introduction</h2>
          <p className="text-sm sm:text-base text-gray-700 mb-2">
            Chez Agroref, nous accordons une grande importance à la protection de vos données personnelles. 
            La présente politique de confidentialité vous informe sur la manière dont nous collectons, 
            utilisons et protégeons vos informations lorsque vous utilisez notre site internet et nos services.
          </p>
          <p className="text-sm sm:text-base text-gray-700">
            En utilisant notre site et nos services, vous acceptez les pratiques décrites dans la présente 
            politique de confidentialité. Nous vous encourageons à la lire attentivement pour comprendre 
            comment vos données personnelles sont traitées.
          </p>
        </section>

        <section>
          <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4">2. Collecte des Données</h2>
          <p className="text-sm sm:text-base text-gray-700 mb-2">
            Nous collectons différents types d'informations lorsque vous utilisez notre site et nos services :
          </p>
          <ul className="list-disc pl-5 text-sm sm:text-base text-gray-700 mb-2">
            <li className="mb-1">
              <strong>Informations que vous nous fournissez :</strong> Nom, prénom, adresse e-mail, adresse postale, 
              numéro de téléphone, informations de paiement, etc., lorsque vous créez un compte, passez une 
              commande ou nous contactez.
            </li>
            <li className="mb-1">
              <strong>Informations collectées automatiquement :</strong> Adresse IP, type de navigateur, fournisseur 
              d'accès à Internet, pages consultées, durée de la visite, heure et date de la visite, et autres 
              statistiques liées à votre navigation sur notre site.
            </li>
            <li>
              <strong>Informations provenant de tiers :</strong> Nous pouvons recevoir des informations vous 
              concernant de la part de tiers, tels que des partenaires commerciaux ou des plateformes de 
              médias sociaux si vous interagissez avec nos contenus sur ces plateformes.
            </li>
          </ul>
        </section>

        <section>
          <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4">3. Utilisation des Données</h2>
          <p className="text-sm sm:text-base text-gray-700 mb-2">
            Les données que nous collectons sont utilisées aux fins suivantes :
          </p>
          <ul className="list-disc pl-5 text-sm sm:text-base text-gray-700 mb-2">
            <li className="mb-1">Traiter et gérer vos commandes, y compris la livraison et les paiements</li>
            <li className="mb-1">Créer et gérer votre compte client</li>
            <li className="mb-1">Vous envoyer des confirmations de commande et des informations sur l'état de vos livraisons</li>
            <li className="mb-1">Répondre à vos questions et fournir un service client efficace</li>
            <li className="mb-1">Améliorer notre site, nos produits et nos services</li>
            <li className="mb-1">Détecter, prévenir et résoudre les problèmes techniques ou de sécurité</li>
            <li className="mb-1">Respecter nos obligations légales et réglementaires</li>
            <li>Vous envoyer, avec votre consentement, des newsletters ou des offres promotionnelles</li>
          </ul>
          <p className="text-sm sm:text-base text-gray-700">
            Nous ne vendons pas vos données personnelles à des tiers et ne les utilisons que dans le cadre 
            strictement nécessaire à la fourniture de nos services.
          </p>
        </section>

        <section>
          <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4">4. Protection des Données</h2>
          <p className="text-sm sm:text-base text-gray-700 mb-2">
            Nous mettons en œuvre des mesures de sécurité appropriées pour protéger vos données personnelles 
            contre tout accès non autorisé, altération, divulgation ou destruction. Ces mesures comprennent 
            notamment :
          </p>
          <ul className="list-disc pl-5 text-sm sm:text-base text-gray-700 mb-2">
            <li className="mb-1">Le cryptage des données sensibles, notamment les informations de paiement</li>
            <li className="mb-1">L'accès restreint aux données personnelles, limité aux employés et prestataires qui en ont besoin pour remplir leurs fonctions</li>
            <li className="mb-1">Des procédures régulières de sauvegarde et de récupération des données</li>
            <li>Des évaluations périodiques de nos systèmes pour identifier et corriger les vulnérabilités potentielles</li>
          </ul>
          <p className="text-sm sm:text-base text-gray-700">
            Bien que nous mettions tout en œuvre pour protéger vos données personnelles, aucune méthode de 
            transmission sur Internet ou de stockage électronique n'est totalement sécurisée. Nous ne pouvons 
            donc garantir une sécurité absolue.
          </p>
        </section>

        <section>
          <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4">5. Partage des Données</h2>
          <p className="text-sm sm:text-base text-gray-700 mb-2">
            Nous pouvons partager vos données personnelles avec :
          </p>
          <ul className="list-disc pl-5 text-sm sm:text-base text-gray-700 mb-2">
            <li className="mb-1">
              <strong>Nos prestataires de services :</strong> transporteurs, services de paiement, fournisseurs 
              d'hébergement et autres prestataires qui nous aident à fournir nos services.
            </li>
            <li className="mb-1">
              <strong>Les autorités publiques :</strong> si nous y sommes tenus par la loi, ou si nous croyons de 
              bonne foi que cela est nécessaire pour respecter une obligation légale, protéger nos droits, 
              assurer votre sécurité ou celle d'autres personnes, enquêter sur une fraude ou répondre à une 
              demande gouvernementale.
            </li>
            <li>
              <strong>En cas de fusion ou d'acquisition :</strong> si notre entreprise fait l'objet d'une fusion, 
              d'une acquisition ou d'une vente d'actifs, vos données personnelles pourraient faire partie des 
              actifs transférés. Vous serez informé par e-mail et/ou par un avis bien visible sur notre site de 
              tout changement de propriétaire ou d'utilisation de vos données personnelles.
            </li>
          </ul>
          <p className="text-sm sm:text-base text-gray-700">
            Dans tous les cas, nous veillons à ce que les tiers avec lesquels nous partageons vos données 
            respectent des normes strictes de confidentialité et de sécurité.
          </p>
        </section>

        <section>
          <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4">6. Vos Droits</h2>
          <p className="text-sm sm:text-base text-gray-700 mb-2">
            Conformément aux lois en vigueur, vous disposez des droits suivants concernant vos données personnelles :
          </p>
          <ul className="list-disc pl-5 text-sm sm:text-base text-gray-700 mb-2">
            <li className="mb-1"><strong>Droit d'accès :</strong> vous pouvez demander une copie des données personnelles que nous détenons à votre sujet.</li>
            <li className="mb-1"><strong>Droit de rectification :</strong> vous pouvez demander la correction des données inexactes ou incomplètes.</li>
            <li className="mb-1"><strong>Droit à l'effacement :</strong> vous pouvez demander la suppression de vos données personnelles dans certaines circonstances.</li>
            <li className="mb-1"><strong>Droit à la limitation du traitement :</strong> vous pouvez demander que nous limitions le traitement de vos données dans certaines circonstances.</li>
            <li className="mb-1"><strong>Droit à la portabilité des données :</strong> vous pouvez demander à recevoir vos données dans un format structuré, couramment utilisé et lisible par machine.</li>
            <li className="mb-1"><strong>Droit d'opposition :</strong> vous pouvez vous opposer au traitement de vos données personnelles dans certaines circonstances.</li>
            <li><strong>Droit de retirer votre consentement :</strong> pour les traitements basés sur le consentement, vous pouvez retirer votre consentement à tout moment.</li>
          </ul>
          <p className="text-sm sm:text-base text-gray-700">
            Pour exercer ces droits, veuillez nous contacter par e-mail à l'adresse indiquée à la fin de cette politique. 
            Nous traiterons votre demande dans les délais prévus par la loi applicable.
          </p>
        </section>

        <section>
          <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4">7. Cookies et Technologies Similaires</h2>
          <p className="text-sm sm:text-base text-gray-700 mb-2">
            Notre site utilise des cookies et d'autres technologies similaires pour améliorer votre expérience de navigation 
            et analyser l'utilisation de notre site. Les cookies sont de petits fichiers texte stockés sur votre appareil 
            lorsque vous visitez notre site.
          </p>
          <p className="text-sm sm:text-base text-gray-700 mb-2">
            Nous utilisons différents types de cookies :
          </p>
          <ul className="list-disc pl-5 text-sm sm:text-base text-gray-700 mb-2">
            <li className="mb-1"><strong>Cookies essentiels :</strong> nécessaires au fonctionnement de notre site et à la fourniture des services que vous demandez.</li>
            <li className="mb-1"><strong>Cookies analytiques :</strong> nous permettent de comprendre comment les visiteurs interagissent avec notre site et d'améliorer son fonctionnement.</li>
            <li className="mb-1"><strong>Cookies de fonctionnalité :</strong> permettent de mémoriser vos préférences et de vous offrir des fonctionnalités améliorées.</li>
            <li><strong>Cookies publicitaires :</strong> utilisés pour vous montrer des publicités pertinentes en fonction de vos centres d'intérêt.</li>
          </ul>
          <p className="text-sm sm:text-base text-gray-700">
            Vous pouvez gérer vos préférences en matière de cookies à tout moment en modifiant les paramètres de votre navigateur. 
            Veuillez noter que la désactivation de certains cookies peut affecter le fonctionnement de notre site.
          </p>
        </section>

        <section>
          <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4">8. Conservation des Données</h2>
          <p className="text-sm sm:text-base text-gray-700 mb-2">
            Nous conservons vos données personnelles aussi longtemps que nécessaire pour atteindre les finalités pour 
            lesquelles elles ont été collectées, notamment pour fournir nos services, respecter nos obligations légales, 
            résoudre les litiges et faire respecter nos accords.
          </p>
          <p className="text-sm sm:text-base text-gray-700">
            Les critères utilisés pour déterminer nos périodes de conservation comprennent :
            <ul className="list-disc pl-5 mt-1">
              <li className="mb-1">La durée pendant laquelle nous entretenons une relation avec vous et vous fournissons nos services</li>
              <li className="mb-1">Nos obligations légales</li>
              <li>Ce qui est souhaitable compte tenu de notre position juridique (par exemple, en ce qui concerne les délais de prescription applicables, les litiges ou les enquêtes réglementaires)</li>
            </ul>
          </p>
        </section>

        <section>
          <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4">9. Transferts Internationaux de Données</h2>
          <p className="text-sm sm:text-base text-gray-700">
            Vos données personnelles peuvent être transférées et traitées dans des pays autres que celui où vous résidez. 
            Ces pays peuvent avoir des lois de protection des données différentes de celles de votre pays. Si nous transférons 
            vos données personnelles à l'étranger, nous prenons des mesures appropriées pour garantir un niveau adéquat de 
            protection, conformément aux exigences légales applicables.
          </p>
        </section>

        <section>
          <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4">10. Modifications de la Politique de Confidentialité</h2>
          <p className="text-sm sm:text-base text-gray-700 mb-2">
            Nous pouvons mettre à jour notre politique de confidentialité de temps à autre pour refléter les changements 
            dans nos pratiques ou pour d'autres raisons opérationnelles, légales ou réglementaires. Nous vous encourageons 
            à consulter régulièrement cette page pour rester informé des dernières modifications.
          </p>
          <p className="text-sm sm:text-base text-gray-700 mb-2">
            En cas de modifications importantes, nous vous en informerons par e-mail ou par un avis bien visible sur notre site avant 
            que les modifications ne prennent effet.
          </p>
          <p className="text-sm sm:text-base text-gray-700">
            La présente politique de confidentialité a été mise à jour pour la dernière fois le 20 mars 2025.
          </p>
        </section>

        <section>
          <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4">11. Contact</h2>
          <p className="text-sm sm:text-base text-gray-700 mb-2">
            Si vous avez des questions ou des préoccupations concernant notre politique de confidentialité ou la façon 
            dont nous traitons vos données personnelles, veuillez nous contacter à l'adresse suivante :
          </p>
          <p className="text-sm sm:text-base text-gray-700 mb-2">
            <strong>Agro-Réfrigération inc</strong><br />
            165 Av. Pie-X<br />
            Victoriaville, QC G6P 6W2<br />
            Canada
          </p>
          <p className="text-sm sm:text-base text-gray-700">
            E-mail : admin@agroref.ca
          </p>
        </section>
      </div>
    </div>
  );
};

export default Confidentialite;
